var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "50px", "min-height": "90vh" } },
    [
      _c("div", { staticClass: "section" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "desc-tip" }, [
          _vm._v(
            "本次举报提供的所有信息，仅用于该投诉的专属处理流程，绝不会向任何第三方泄露。投诉举报经核实事实成立的，有现金奖励，价值越大奖励越高。"
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "margin-left": "11px",
              display: "flex",
              "flex-direction": "column"
            }
          },
          [
            _c(
              "ToggleRadioItem",
              {
                attrs: { name: 1 },
                model: {
                  value: _vm.selectedCategory,
                  callback: function($$v) {
                    _vm.selectedCategory = $$v
                  },
                  expression: "selectedCategory"
                }
              },
              [_vm._v("管理不公")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "desc-tip",
                staticStyle: { "margin-left": "11px", color: "darkgray" }
              },
              [_vm._v("管理不公（绩效、任务、奖惩、职场态度等）")]
            ),
            _vm._v(" "),
            _vm.selectedCategory === 1
              ? _c("div", { staticClass: "sub-group" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column"
                      }
                    },
                    _vm._l(_vm.subOptions1, function(opt, i) {
                      return _c(
                        "ToggleRadioItem",
                        {
                          key: "c1-" + opt.id,
                          attrs: { name: opt.id },
                          model: {
                            value: _vm.selectedSubId,
                            callback: function($$v) {
                              _vm.selectedSubId = $$v
                            },
                            expression: "selectedSubId"
                          }
                        },
                        [_vm._v(_vm._s(opt.value))]
                      )
                    }),
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ToggleRadioItem",
              {
                attrs: { name: 2 },
                model: {
                  value: _vm.selectedCategory,
                  callback: function($$v) {
                    _vm.selectedCategory = $$v
                  },
                  expression: "selectedCategory"
                }
              },
              [_vm._v("平台数据泄露")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "desc-tip",
                staticStyle: { "margin-left": "11px", color: "darkgray" }
              },
              [_vm._v("平台商家数据泄露（外传、滥用、留存等）")]
            ),
            _vm._v(" "),
            _vm.selectedCategory === 2
              ? _c("div", { staticClass: "sub-group" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column"
                      }
                    },
                    _vm._l(_vm.subOptions2, function(opt, i) {
                      return _c(
                        "ToggleRadioItem",
                        {
                          key: "c2-" + opt.id,
                          attrs: { name: opt.id },
                          model: {
                            value: _vm.selectedSubId,
                            callback: function($$v) {
                              _vm.selectedSubId = $$v
                            },
                            expression: "selectedSubId"
                          }
                        },
                        [_vm._v(_vm._s(opt.value))]
                      )
                    }),
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ToggleRadioItem",
              {
                attrs: { name: 3 },
                model: {
                  value: _vm.selectedCategory,
                  callback: function($$v) {
                    _vm.selectedCategory = $$v
                  },
                  expression: "selectedCategory"
                }
              },
              [_vm._v("谋取私利")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "desc-tip",
                staticStyle: { "margin-left": "11px", color: "darkgray" }
              },
              [_vm._v("谋取私利（收礼、分成、资源倾斜等）")]
            ),
            _vm._v(" "),
            _vm.selectedCategory === 3
              ? _c("div", { staticClass: "sub-group" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column"
                      }
                    },
                    _vm._l(_vm.subOptions3, function(opt, i) {
                      return _c(
                        "ToggleRadioItem",
                        {
                          key: "c3-" + opt.id,
                          attrs: { name: opt.id },
                          model: {
                            value: _vm.selectedSubId,
                            callback: function($$v) {
                              _vm.selectedSubId = $$v
                            },
                            expression: "selectedSubId"
                          }
                        },
                        [_vm._v(_vm._s(opt.value))]
                      )
                    }),
                    1
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section" },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("van-field", {
            staticStyle: {
              "font-size": "110%",
              "max-height": "65px",
              overflow: "auto"
            },
            attrs: {
              type: "textarea",
              maxlength: "999",
              "show-word-limit": "",
              rows: "2",
              autosize: "",
              placeholder: "请填写投诉内容"
            },
            model: {
              value: _vm.ticketNew.orderContent,
              callback: function($$v) {
                _vm.$set(_vm.ticketNew, "orderContent", $$v)
              },
              expression: "ticketNew.orderContent"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section" },
        [_vm._m(2), _vm._v(" "), _c("MobileTicketUploadBig", { ref: "up6" })],
        1
      ),
      _vm._v(" "),
      _c(
        "MobileSubmitButton",
        {
          ref: "subBtn_1",
          staticStyle: {
            transform: "translateX(-50%)",
            left: "50%",
            "margin-top": "30px"
          },
          on: { click: _vm.newTicket_1 }
        },
        [_vm._v("提交")]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { height: "15vh" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "req-title" }, [
      _c("span", { staticClass: "asterisk" }, [_vm._v("*")]),
      _vm._v(" 请选择你想投诉的问题")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "req-title", staticStyle: { "margin-top": "10px" } },
      [
        _c("span", { staticClass: "asterisk" }, [_vm._v("*")]),
        _vm._v(" 请具体描述投诉内容")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "req-title" }, [
      _c("span", { staticClass: "asterisk" }, [_vm._v("*")]),
      _vm._v(" 请上传投诉凭证")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b80800ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b80800ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-ticket/MobileTicketComplaintNew.vue
// module id = 636
// module chunks = 75